<script lang="ts">
    import {createEventDispatcher, onDestroy, onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";
    import {ValueUtil} from "../../../lib/Common/Value/ValueUtil";
    import {SizeUtil} from "../../../lib/Common/Value/SizeUtil";
    import CloseButtonView from "../Button/CloseButtonView.svelte";

    const dispatch = createEventDispatcher();

    export let supportFileExtensionArray = null;

    export let isMultiple = false; // true の場合、複数ファイル対応
    export let isShowActiveFileArray = false; // 指定したファイルを表示
    export let isHideClearButton = false;


    export let canUploadFolder = false;
    export let canPaste = false;

    export let isShowLabel = true;
    export let widthPx = null;
    export let heightPx = null;

    let inputElement: any = null;

    // 現在指定したファイル。表示用に使用
    let activeFileArray = null;

    const clipboardImageExtension = 'png';
    const clipboardImageMimetype = 'image/png';


    $: accept = (() => {
        if (supportFileExtensionArray == null) {
            return '*';
        }
        const acceptArray = [];
        for (let supportFileExtension of supportFileExtensionArray) {
            acceptArray.push(`.${supportFileExtension}`);
        }
        const accept = acceptArray.join(',');
        return accept;
    })();

    $: canPasteImage = (() => {
        if (!canPaste) {
            return false;
        }
        if (supportFileExtensionArray == null) {
            return false;
        }
        if (supportFileExtensionArray.includes(clipboardImageExtension)) {
            // png が含まれている場合
            return true;
        } else {
            return false;
        }

    })();

    $: activeFileMessage = (() => {
        if (!isShowActiveFileArray) {
            return null;
        }
        if (activeFileArray == null) {
            return null;
        }
        const activeFileTextArray = [];
        for (let file of activeFileArray) {
            const fileName = file.name;
            const fileSize = file.size;
            const prettyFileSize = SizeUtil.formatBytes(fileSize);
            const message = `${fileName} ${prettyFileSize}`;
            activeFileTextArray.push(message);
        }
        const activeFileMessage = activeFileTextArray.join("\n");
        return activeFileMessage;
    })();

    $: isShowClearButton = (() => {
        if (activeFileArray == null) {
            return false;
        }
        if (isHideClearButton) {
            return false;
        }

        return true;
    })();

    $: style = (() => {
        const styleArray = [];

        if (widthPx != null) {
            styleArray.push(`width: ${widthPx}px`);
        }
        if (heightPx != null) {
            styleArray.push(`height: ${heightPx}px`);
        }

        const style = styleArray.join(';');
        return style;
    })();

    onMount(() => {
        // console.log('onMount');
        // console.log('window.addEventListener');
        window.addEventListener("paste", onPaste);
    });

    onDestroy(() => {
        // console.log('window.removeEventListener');
        window.removeEventListener("paste", onPaste);
    })

    /**
     * クリップボードの貼り付け
     * @param event
     */
    function onPaste(event: ClipboardEvent) {
        if (!canPasteImage) {
            // 画像の貼り付けが有効でない場合は処理しない
            return;
        }

        // 画像の貼り付けに対応
        const clipboardData = event.clipboardData;
        if (clipboardData == null) {
            return;
        }
        const clipboardDataFiles = clipboardData.files;
        if (clipboardDataFiles == null) {
            return;
        }
        if (clipboardDataFiles.length === 0) {
            return;
        }
        const clipboardDataFile = clipboardDataFiles[0];

        // 画像貼り付けは png のみのため、この拡張子のみ受付
        switch (clipboardDataFile.type) {
            case clipboardImageMimetype:
                // ok
                break;
            default:
                console.log('clipboardDataFile.type', clipboardDataFile.type);
                return;
        }


        const clipboardFileArray = [clipboardDataFile];
        // ファイルを追加
        addFileArray(clipboardFileArray);

    }


    /**
     * ドラッグ
     * @param event
     */
    function onDrop(event) {
        // console.log("onDrop");
        const dropFiles = event.dataTransfer.files;

        const dropFileArray = Array.from(dropFiles);


        // ファイルを追加
        addFileArray(dropFileArray);


    }

    /**
     * ファイル指定
     * @param event
     */
    function onChange(event) {
        // console.log('onChange', event);
        const targetElement = event.target;
        const files = targetElement.files;
        if (files.length == 0) {
            return;
        }
        const fileArray = Array.from(files);
        // const file = files[0];
        // ファイルを追加
        addFileArray(fileArray);

    }

    /**
     * フォルダ指定
     * @param event
     */
    function onChangeFolder(event) {
        if (!canUploadFolder) {
            // フォルダのアップロードができない場合は処理しない
            return;
        }
        // console.log('onChangeFolder', {event});
        const targetElement = event.target;
        const files = targetElement.files;
        const fileArray = Array.from(files);

        // ファイルを追加
        addFileArray(fileArray);
    }

    /**
     * ファイル配列の追加
     * @param fileArray
     */
    function addFileArray(fileArray) {
        if (fileArray.length === 0) {
            return;
        }

        dispatch('add', {
            fileArray: fileArray,
            file: fileArray[0],
        });

        activeFileArray = fileArray;
        inputElement.value = '';
        console.log({activeFileArray});
    }

    function onClickClear(event) {
        if (!isShowClearButton) {
            return;
        }
        dispatch('clear');


        activeFileArray = null;
        inputElement.value = '';
    }

</script>
<div class="file-upload-input-view"
     style={style}
>


    <label class="file-area"
           on:drop|preventDefault|stopPropagation={onDrop}
           on:dragover={(ev) => { ev.preventDefault() }}
    >
        <div class="message">
            {#if ValueUtil.isEmpty(activeFileMessage)}
                {#if isShowLabel}
                    <div class="text sentence-separate">
                        {#if canPasteImage}
                            <span>クリックしてファイルを選択するか、</span>
                            <span>ファイルをドラッグするか、</span>
                            <span>ブラウザ上で画像をコピーして</span>
                            <span>貼り付けしてください</span>
                        {:else}
                            <span>クリックしてファイルを選択するか、</span>
                            <span>ファイルをドラッグしてください</span>
                        {/if}
                    </div>
                {/if}

                <div class="active-file-area">
                    {#if activeFileArray != null}
                        {#each activeFileArray as activeFile}
                            <div class="file-name">
                                { activeFile.name }
                            </div>
                        {/each}
                    {/if}
                </div>

                <div class="accept-area">
                    {#if isShowLabel}
                        <div>[対応ファイル形式]</div>
                    {/if}
                    <div class="accept">
                        {#each supportFileExtensionArray as supportFileExtension}
                            <span>{supportFileExtension}</span>
                        {/each}
                    </div>
                </div>
            {:else}
                <div class="text sentence-separate">
                    {activeFileMessage}
                </div>
            {/if}
        </div>

        <input type="file" accept={accept}
               bind:this={inputElement}
               multiple={isMultiple}
               on:change={onChange}
        />


        {#if isShowClearButton}
            <div class="clear-button">
                <CloseButtonView on:click={onClickClear}/>
            </div>
        {/if}

    </label>

    {#if canUploadFolder}
        <div class="upload-folder-area">
            <label class="folder-label">
                <div class="message">
                    <FontAwesomeView icon="folder"/>
                    フォルダーで一括アップロードする
                </div>
                <div class="warning-message">
                    間違ったファイルをアップロードしないよう、慎重に扱ってください
                </div>
                <input type="file" webkitdirectory
                       on:change={onChangeFolder}
                />

            </label>
        </div>
    {/if}


</div>
<style lang="scss">
    .file-upload-input-view {
        height: 100%;
        width: 100%;

        display: flex;
        flex-direction: column;

        .file-area {
            display: inline-block;
            flex-grow: 1;
            width: 100%;
            position: relative;

            border-style: solid;
            border-radius: 8px;
            border-color: #0003;
            border-width: 1px;

            background-color: var(--background-color);
            cursor: pointer;

            > .message {
                margin: 24px;
                opacity: 0.5;

                .active-file-area {
                    .file-name {
                        font-size: 0.5em;
                        white-space: pre-wrap;
                        word-break: break-word;
                    }
                }

                .accept-area {
                    margin-top: 16px;
                    font-size: 0.8em;
                    text-align: center;

                    .accept {
                        display: flex;
                        gap: 8px;
                        justify-content: center;
                        flex-wrap: wrap;
                    }

                }
            }

            .files-area {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 12px;

                .file-name {
                    border-style: solid;
                    border-radius: 4px;
                    border-color: #0003;
                    padding: 0.5em;
                }
            }

            input[type='file'] {
                display: none;
            }

            &:hover {
                opacity: 0.5;
            }

            .clear-button {
                position: absolute;
                right: 0;
                top: 0;
            }
        }

        .upload-folder-area {
            padding-top: 12px;
            display: flex;
            align-items: center;
            justify-content: center;

            font-size: 0.8em;

            .folder-label {
                border-style: solid;
                border-radius: 8px;
                border-color: #0003;
                border-width: 1px;

                height: 32px;

                padding-left: 2em;
                padding-right: 2em;

                background-color: var(--background-color);
                cursor: pointer;

                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .message {
                    opacity: 0.5;
                }

                .warning-message {
                    opacity: 0.5;
                    font-size: 0.5em;
                    color: var(--danger-color);
                }

                input[type='file'] {
                    display: none;
                }

                &:hover {
                    opacity: 0.5;
                }

            }

        }

    }
</style>